import { useState, useCallback } from 'react'

/**
 * Custom hook for managing delete modal state
 * Reduces code duplication across components using DeleteCompetitionModal
 */
export const useDeleteModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  return {
    isOpen,
    open,
    close,
    toggle,
  }
}

export default useDeleteModal
